import { Link } from "react-router-dom";
import { Navbar } from "../components/layout/Navbar";
import { Footer } from "../components/layout/Footer";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { ArrowRight, TrendingUp, Users, Lightbulb, Globe, Building2, HandshakeIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { HeroSection } from "../components/landing/HeroSection";
import { HowItWorksSection } from "../components/landing/HowItWorksSection";
import { ProgramSection } from "../components/landing/ProgramSection";
import { ProjectsPreview } from "../features/projects/components/ProjectsPreview";
import { TestimonialsSection } from "../components/landing/TestimonialsSection";
import { CTASection } from "../components/landing/CTASection";
import { useAuth } from "../contexts/AuthContext";

const PublicHome = () => {
  const { language, t } = useLanguage();
  const { user, userType } = useAuth();

  const stats = [
    {
      icon: Users,
      value: "50+",
      label: t('public.stats.activeInvestors'),
      description: t('public.stats.activeInvestorsDesc')
    },
    {
      icon: Lightbulb,
      value: "100+",
      label: t('public.stats.fundedProjects'),
      description: t('public.stats.fundedProjectsDesc')
    },
    {
      icon: TrendingUp,
      value: "$50M+",
      label: t('public.stats.totalFunding'),
      description: t('public.stats.totalFundingDesc')
    },
    {
      icon: Globe,
      value: "15+",
      label: t('public.stats.sectors'),
      description: t('public.stats.sectorsDesc')
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />

      <main className="flex-1">
        {/* Hero Section */}
        <HeroSection />
        <HowItWorksSection />
        <ProgramSection />
        <ProjectsPreview />
        {/*  <TestimonialsSection />*/}
        <CTASection />



        {/* Stats Section */}
        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <Card key={index} className="text-center border-border p-4">
                  <CardHeader className="p-4">
                    <div className="mx-auto bg-primary/10 p-3 rounded-full mb-4">
                      <stat.icon className="w-6 h-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl sm:text-2xl">{stat.value}</CardTitle>
                  </CardHeader>
                  <CardContent className="p-4 pt-0">
                    <CardDescription className="font-medium mb-2 text-sm sm:text-base">{stat.label}</CardDescription>
                    <p className="text-xs sm:text-sm text-muted-foreground">{stat.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PublicHome;